
export class TipoConnettivitaMPLS {
    id: Number;
    codice: String;
    descrizione: String;

  }
  